import { ContentContainer } from "components/ui/display/ContentContainer";
import styled from "styled-components";
import { ViewSwitch } from "components/ui/controls/ViewSwitch";
import { useState } from "react";
import { ProjectsActivityPrediciton } from "./ProjectsActivityPrediction";
import { ProjectsActivityCapacity } from "./ProjectsActivityCapacity";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";


export const ProjectsActivityContainer = ({projects}) => {

    const [selectedView, setSelectedView] = useState('prediction');

    return (
        <StyledProjectActivityContainer
            padding='none'
        >
            <div className="activityHeader">
                <div className="title">
                    <MaterialIcon
                        name='schedule'
                        weight={300}
                        size='sm'
                    />
                    Timeprognose per prosjekt
                </div>
                <ViewSwitch
                    firstOptionName='Timeforbruk'
                    secondOptionName='Kapasitet'
                    firstOptionValue='prediction'
                    secondOptionValue='capacity'
                    selected={selectedView}
                    onChange={(e) => setSelectedView(e)}
                />
            </div>
            <div className="activityContent">
                {
                    selectedView === 'prediction'
                    ? <ProjectsActivityPrediciton projects={projects.filter(prj => prj.projectActivity.enabled && prj.projectActivity.displayOnDashboard)}/>
                    : <ProjectsActivityCapacity projects={projects.filter(prj => prj.projectActivity.enabled && prj.projectActivity.useToCalculateAvailability)}/>
                }
            </div>
        </StyledProjectActivityContainer>
    )
}

const StyledProjectActivityContainer = styled(ContentContainer)`
    
    min-height: 400px;
    max-height: 500px;
    overflow: hidden;

    @media (min-width: ${({theme}) => theme.breakPoints.xl})
    {
        flex: 2 0 0;
    }

    @media (max-width: ${({theme}) => theme.breakPoints.xl})
    {
        width: 100%;        
    }

    div.activityHeader
    {
        padding: ${({theme}) => theme.spacing.md};
        border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        display: flex;
        justify-content: space-between;
        align-items: center;

        div.title
        {
            display: flex;
            align-items: center;
            gap: ${({theme}) => theme.spacing.md};
            font-weight: 600;

            .icon
            {
                color: ${({theme}) => theme.colors.mutedForeground};
            }
        }
    }

    div.activityContent
    {
        padding: ${({theme}) => theme.spacing.md};
        flex: 1 0 0;
        overflow: hidden;
    }
`

